/* eslint-disable react/jsx-indent */
import React, { PropTypes } from 'react';
import styled from 'styled-components';
import { media } from 'style-utils';

import { INSIGHTS } from '../../../../routes/const';
import { updateCurrentRole } from '../utils';

const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  color: ${props => props.theme.color.gunmetal};

  ${media.mobileTablet`
    padding: 20px 0 0 0;
    margin: 0 16px;
  `}

  input {
    position: absolute !important;
    clip: rect(0, 0, 0, 0);
    height: 1px;
    width: 1px;
    border: 0;
    overflow: hidden;
    &:checked + label {
      font-family: noto-sans-bold;
      color: ${props => props.theme.color.gunmetal};
      opacity: 1;
      text-decoration: underline;
    }
  }
  label {
    opacity: 0.5;
    font-size: 14px;
    line-height: 1;
    text-align: center;
    padding: 1px;
    margin: 4px;
    transition: all 0.1s ease-in-out;
    &:hover {
      cursor: pointer;
    }
  }
`;

const CountrySwitcher = (
  {
    close,
    roles,
    role,
    costCenters,
    changeCurrentRole,
    setGlobalCountryCostCenter,
    setGlobalDynamicFilter
  },
  context
) => {
  const onChange = country => {
    updateCurrentRole(
      roles,
      costCenters,
      country,
      'ROLECOUNTRYSWITCHCHANGE',
      (newRole, costCenter) => {
        changeCurrentRole(newRole);
        setGlobalDynamicFilter([]);
        setGlobalCountryCostCenter(costCenter);
        if (close) {
          close();
        }
        context.router.push(INSIGHTS);
      }
    );
  };

  const roleCountries = roles ? roles.map(e => e.country) : [];

  return (
    roleCountries.includes('AU') &&
    roleCountries.includes('NZ') && (
      <ToggleContainer>
        <input
          type="radio"
          id="radio-au"
          name="switch-country"
          value="AU"
          checked={role.country === 'AU'}
          onChange={() => onChange('AU')}
        />
        <label htmlFor="radio-au">AU</label>
        |
        <input
          type="radio"
          id="radio-nz"
          name="switch-country"
          value="NZ"
          checked={role.country === 'NZ'}
          onChange={() => onChange('NZ')}
        />
        <label htmlFor="radio-nz">NZ</label>
      </ToggleContainer>
    )
  );
};

CountrySwitcher.contextTypes = {
  router: PropTypes.shape({})
};

CountrySwitcher.propTypes = {
  roles: PropTypes.arrayOf(PropTypes.shape({})),
  role: PropTypes.shape({}),
  changeCurrentRole: PropTypes.func,
  setGlobalDynamicFilter: PropTypes.func
};

CountrySwitcher.defaultProps = {
  roles: [],
  role: null,
  changeCurrentRole: () => {},
  setGlobalDynamicFilter: () => {}
};

export default CountrySwitcher;



// WEBPACK FOOTER //
// ./src/components/common/Profile/CountrySwitcher/CountrySwitcherComponent.js